import { MONITOR_ROLE_ID } from "../hooks/useIsMonitor";
import { PTAR_ROLE_IDS_WITHOUT_ADMIN_APP } from "../hooks/useTruckYardRole";

/**
 * Quién no puede entrar a `/admin` (Admin Flotilla).
 *
 * La parte de patios se DERIVA de la tabla de apps de useTruckYardRole en vez
 * de enumerarse acá, y ese cambio es la mitad menos visible de #558: `/admin`
 * nunca se protegió por `*_ALLOWED_APPS` sino por esta lista, así que sacarle
 * la app a un rol en el sidebar y prohibirle la ruta eran dos ediciones
 * separadas — y la segunda es la que se olvida. Sin ella, ocultar la app no
 * impide llegar por bookmark, por URL a mano, ni por el `lastRoute` que la app
 * restaura sola al abrir.
 *
 * Vive en su propio archivo, y no en router/config.tsx donde nació, porque
 * ahora la leen dos: el guard de la ruta y quien dibuja un ENLACE hacia
 * `/admin/...` (el modal de inspección → notificaciones). Si cada uno tuviera
 * su copia, el día que un rol pierda la app el enlace seguiría a la vista y
 * llevaría a `/map`, que es a donde redirige el guard.
 */
export const ADMIN_APP_RESTRICTED_ROLE_IDS: string[] = [
  MONITOR_ROLE_ID,
  ...PTAR_ROLE_IDS_WITHOUT_ADMIN_APP,
];

/**
 * ¿Este rol llega a una pantalla de `/admin`? Mismo criterio que
 * `RoleProtectedRoute` con `restrictedRoleIds`: sin rol conocido se deja pasar
 * (el guard tampoco lo frena), con un rol de la lista no.
 */
export function canEnterAdminApp(roleId: string | null | undefined): boolean {
  return !(roleId && ADMIN_APP_RESTRICTED_ROLE_IDS.includes(roleId));
}
